/**
 * TerminalPage
 * Landing page displaying the Falcon Terminal studio selector
 */

import React from "react";

import { useNavigate } from "react-router-dom";

import { AUTH_ROUTES } from "@/features/auth/routes";
import { useAuthStore } from "@/features/auth/store/authStore";

import { FalconTerminal } from "../components/FalconTerminal";

export const TerminalPage: React.FC = () => {
  const navigate = useNavigate();
  const logout = useAuthStore((state) => state.logout);

  const handleStudioSelect = (studioId: string) => {
    switch (studioId) {
      case "strategy":
        navigate("/strategy");
        break;
      case "innovation":
        navigate("/innovation");
        break;
      case "insights":
        navigate("/analysis");
        break;
      default:
        break;
    }
  };

  const handleLogout = () => {
    logout();
    navigate(AUTH_ROUTES.LOGIN);
  };

  return (
    <FalconTerminal
      onStudioSelect={handleStudioSelect}
      onLogout={handleLogout}
    />
  );
};

export default TerminalPage;
